export const ensureHttpPrefix = (url) => {
    if (url) {
        if (!url.startsWith("http://") && !url.startsWith("https://")) {
            url = "http://" + url;
        }
        return url;
    } else {
        return '';
    }
}